import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingTable } from './components/PricingTable';
import { Accelerator } from './components/Accelerator';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
import { BottomPricing } from './components/BottomPricing';
export function App() {
  const testimonials1 = [{
    initials: 'VL',
    name: 'Valentina L.',
    location: 'Córdoba',
    text: 'Nunca había calculado mis costos reales. Subí los precios un 40% con fundamento y no perdí ninguna clienta que importara.'
  }, {
    initials: 'MS',
    name: 'Micaela S.',
    location: 'Rosario',
    text: 'Con los scripts del Bono 2 cerré 4 turnos el mismo día que los cargué en WhatsApp Business.'
  }, {
    initials: 'CG',
    name: 'Carolina G.',
    location: 'Buenos Aires',
    text: 'Al mes de aplicar el sistema tenía la agenda llena, política de seña activa y mis primeras reseñas de Google.'
  }];
  const testimonials2 = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    text: 'El Tomo 3 me abrió los ojos. Estaba cobrando $4.000 menos por servicio de lo que necesitaba. Subí los precios, apliqué el guión del Bono 2 y no perdí ninguna clienta seria.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    text: 'El sistema de fidelización del Tomo 5 fue un antes y un después. El 75% de mis clientas ahora vuelve sola. No necesito correr atrás de nadie.'
  }, {
    initials: 'SA',
    name: 'Sofía A.',
    location: 'Neuquén',
    text: 'Solté 3 clientas tóxicas con el Bono 6 y en 3 semanas esos lugares los ocuparon clientas que pagan sin regatear. Trabajo menos horas y gano más.'
  }, {
    initials: 'PA',
    name: 'Paula A.',
    location: 'Mar del Plata',
    text: 'En 30 días con el Acelerador logré más que en 2 años improvisando. La agenda llena, los precios actualizados y mis primeras 12 reseñas en Google.'
  }];
  return <div className="min-h-screen bg-dark text-white selection:bg-brand selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials testimonials={testimonials1} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Bonuses data-id="element-6" />

      <section className="py-12 px-4 text-center bg-dark-card border-y border-dark-border" data-id="element-7">
        <div className="max-w-3xl mx-auto" data-id="element-8">
          <div className="text-brand font-bold mb-4 tracking-widest text-sm" data-id="element-9">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <CountdownTimer data-id="element-10" />
          <div className="mt-4 flex items-center justify-center space-x-2" data-id="element-11">
            <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-12" />
            <span className="text-sm text-gray-400" data-id="element-13">
              Quedan pocos cupos al precio de lanzamiento
            </span>
          </div>
          <div className="w-full max-w-md mx-auto h-2 bg-dark rounded-full mt-4 overflow-hidden" data-id="element-14">
            <div className="h-full bg-brand w-[68%]" data-id="element-15" />
          </div>
          <div className="text-xs text-gray-500 mt-2" data-id="element-16">
            68% de los cupos ya tomados
          </div>
        </div>
      </section>

      <PricingTable data-id="element-17" />
      <Accelerator data-id="element-18" />

      <div className="py-12 pt-[15px] pb-[15px]" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-3xl font-black" data-id="element-21">
            ❤️ MÁS MANICURISTAS QUE YA LO TIENEN
          </h2>
        </div>
        <Testimonials testimonials={testimonials2} data-id="element-22" />
      </div>

      <Guarantee data-id="element-23" />
      <FAQ data-id="element-24" />
      <CostSection data-id="element-25" />

      <BottomPricing data-id="element-26" />

      <Footer data-id="element-27" />
    </div>;
}